export default __webpack_public_path__ + "static/media/netbit1.48331c39.png";